import { Button, Modal } from 'antd';
import { toast } from 'react-toastify';
import ApiService from '../../core/service/api-service';

// Kalıcı silme onayı (satır menüsü ve Operasyonlar ortak).
//  - Tamam: PACS'tan siler + RIS kaydını silindi işaretler (mevcut akış).
//  - PACS : yalnız PACS'tan siler, RIS'te hiçbir şey değişmez — görüntüler cihazdan yeniden
//           gönderilecekse aynı çekim kaydına düşsün diye. Ekranda değişiklik olmayacağı için
//           başarı ayrıca bildirilir.
export function confirmPermanentDelete({ t, studyIdList, onDeleted }) {
    const deleteStudies = async (pacsOnly) => {
        const response = await ApiService.Study.DeleteStudiesPermanent(studyIdList, { pacsOnly });
        if (!response.success) {
            return;
        }

        if (pacsOnly) {
            toast.success(t('Studies deleted from PACS'));
        } else if (onDeleted) {
            await onDeleted();
        }
    };

    const modal = Modal.confirm({
        title: t('Confirm Permanent Deletion'),
        content: (
            <>
                <p>{t('This is a critical operation. Permanently deleting studies cannot be undone. Are you sure?')}</p>
                <p style={{ marginBottom: 0 }}>{t('PERMANENT_DELETE_OPTIONS_DESC')}</p>
            </>
        ),
        okText: t('OK'),
        cancelText: t('Cancel'),
        onOk: () => deleteStudies(false),
        footer: (_, { OkBtn, CancelBtn }) => (
            <>
                <CancelBtn />
                <Button
                    danger
                    onClick={() => {
                        modal.destroy();
                        deleteStudies(true);
                    }}
                >
                    PACS
                </Button>
                <OkBtn />
            </>
        ),
    });
}
